import { render, staticRenderFns } from "./CargarPrecios.vue?vue&type=template&id=3952effc"
import script from "./CargarPrecios.vue?vue&type=script&lang=js"
export * from "./CargarPrecios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports